<h1 class="page-title">Categories</h1>

<p class="loading" *ngIf="loading">Loading…</p>
<p class="commit-error" *ngIf="error">{{ error }}</p>

<div class="group-card" *ngFor="let row of rows; trackBy: trackGroup">
  <div class="group-head">
    <span class="swatch" [style.background]="row.group.color"></span>
    <span class="group-name">{{ row.group.name }}</span>
    <span class="group-meta" *ngIf="!row.group.isSpending">excluded from spending</span>
  </div>

  <div class="cat" *ngFor="let cr of row.categories; trackBy: trackCategory">
    <div class="cat-head">
      <span class="cat-name">{{ cr.category.name }}</span>
      <button class="link-btn" (click)="removeCategory(cr.category.id)">remove</button>
    </div>
    <div class="rule" *ngFor="let rule of cr.rules; trackBy: trackRule">
      <code>{{ rule.pattern }}</code>
      <span class="hits">{{ rule.hitCount }} hits</span>
      <button class="link-btn" (click)="removeRule(rule.id)">×</button>
    </div>
  </div>

  <div class="add-row">
    <input class="add-input"
           [(ngModel)]="newNames[row.group.id]"
           (keyup.enter)="addCategory(row.group.id)"
           placeholder="New category…">
    <button class="add-btn" (click)="addCategory(row.group.id)">Add</button>
  </div>
</div>

<div class="guard" *ngIf="pendingDelete">
  <p class="guard-msg">{{ guardMessage }}. Reassign them, then delete:</p>
  <p class="guard-note" *ngIf="pendingDelete.hasBudget">
    Its budget is removed with it. Any per-month overrides you set go too, and a
    target that already has a limit keeps its own.
  </p>
  <p class="guard-error" *ngIf="error">{{ error }}</p>
  <select class="guard-select" [(ngModel)]="pendingDelete.toId">
    <option value="" disabled>Reassign to…</option>
    <ng-container *ngFor="let row of rows">
      <option *ngFor="let cr of row.categories"
              [value]="cr.category.id"
              [disabled]="cr.category.id === pendingDelete.categoryId">
        {{ row.group.name }} · {{ cr.category.name }}
      </option>
    </ng-container>
  </select>
  <button class="add-btn" (click)="confirmDelete()"
          [disabled]="!pendingDelete.toId">Reassign &amp; delete</button>
  <button class="link-btn" (click)="cancelDelete()">cancel</button>
</div>
